<template>
    <v-dialog v-model="showLinkEventModal" transition="slide-x-transition" max-width="500">
        <v-card :loading="loading" :disabled="loading" flat>
            <v-toolbar dark dense>
                <v-toolbar-title>
                    Události k připojení
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                    <v-btn fab x-small color="error" @click="close">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar-items>
            </v-toolbar>
            <api-data-loader ref="list" :api-path="'/v2/events/' + event.id + '/link'">
                <template #item="{ item }">
                    <div class="d-flex">
                        <event-head-inactive :event="item" :link="false">
                            <template v-slot:actions>
                                <v-btn color="primary" @click="linkEvent(item)">Připojit</v-btn>
                            </template>
                        </event-head-inactive>
                    </div>
                </template>
            </api-data-loader>
        </v-card>
    </v-dialog>
</template>

<script>

import ApiDataLoader from "@/components/ui/ApiDataLoader.vue";
import EventHeadInactive from "@/components/panel/sidebar/event/HeadInactive.vue";
import api from "@/api/api";

export default {
    name: 'list-events-for-link',
    components: {EventHeadInactive, ApiDataLoader},
    props: {
        event: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            loading: false,
        }
    },
    computed: {
        showLinkEventModal: {
            get() {
                return this.$store.state.events.showLinkEventModal;
            },
            set(value) {
                this.$store.commit('events/SET_SHOW_LINK_EVENT_MODAL', value);
            }
        },
    },
    methods: {
        close() {
            this.$store.commit('events/SET_SHOW_LINK_EVENT_MODAL', false);
        },
        async linkEvent(item) {
            try {
                this.loading = true;
                await api.post('/v2/event-to-events/' + this.event.id + '/' + item.id, {});
                this.$noty.success('Připojeno');
                await this.$refs.list.refresh();
            } catch (error) {
                console.error('Chyba při připojení události:', error);
                this.hasMore = false;
            } finally {
                this.loading = false;
            }
        },
    }
}
</script>
